<div class="checkout-stepper">
	<div class="content-columns">
		<div class="main-column">
			<section class="panel main-panel" [class.collapsed]="currentStep!==1">
				<div class="panel-header"><!--(click)="goToStep(1)"-->
					<div class="header-left">
						<div class="header-title">
							<span class="step-badge-large">1</span>
							<h5 class="step-badge-text">Request for Quote Details</h5>
						</div>
						<p class="hint">Please fill in your information</p>
					</div>
					<div class="header-right">
						<button type="button" class="edit-button" [disabled]="!shippingSubmitted"
							(click)="editShipping($event)">Edit</button>
						<!-- <button class="toggle" (click)="togglePanel($event,1)" aria-label="Toggle Shipping Details">
							<cx-icon class="cx-icon fas fa-angle-right flip-at-rtl chev" [class.open]="currentStep===1"></cx-icon>
						</button> -->
					</div>
				</div>

				<div class="panel-body">
					<div class="form-area">
						<kn-br-request-quote-details #shippingDetails></kn-br-request-quote-details>

						<div class="actions bottom-actions continue-btn">
							<button class="btn btn-primary" type="button" [disabled]="shippingDetails.shippingForm.invalid"
								(click)="submitShippingDetails()">Continue</button>
						</div>
					</div>
				</div>
			</section>

			<section class="panel review-panel" [class.collapsed]="currentStep!==2">
				<div class="panel-header"><!--(click)="goToStep(2)"-->
					<div class="header-left">
						<div class="header-title">
							<span class="step-badge-large">2</span>
							<h5 class="step-badge-text">Review Request</h5>
						</div>
						<p class="hint">Please review your request information and items before submitting.</p>
					</div>
					<div class="header-right">
						<!-- <button class="toggle" (click)="togglePanel($event,2)" aria-label="Toggle Review Order">
							<cx-icon class="cx-icon fas fa-angle-right flip-at-rtl chev" [class.open]="currentStep===2"></cx-icon>
						</button> -->
					</div>
				</div>

				<div class="panel-body">
					<knbr-request-quote-review></knbr-request-quote-review  >
					<!-- <div class="actions">
						<button type="button" class="btn btn-primary" (click)="previous()">Back</button>
					</div> -->
				</div>
			</section>
		</div>

		<aside class="sidebar">
			<label class="quote-summary-label">Quote Summary</label>
			<div class="total-estimation">
				<label>Total(Est.)</label>
				<label>{{ totalPrice?.value === 0 ? 'Quoted' : totalPrice?.formattedValue }}</label>
			</div>
			<div class="disclaimer-section">
				<div class="disclaimer-icon">
					<i class="fas fa-info-circle"></i>
				</div>
				<div class="disclaimer-content">
					<p>This is an estimate only.</p>
					<p>Final pricing will be provided in your quote.</p>
				</div>
			</div>
			<label>PO/Job Number <span class="optional">(optional)</span>
				<input type="text" [(ngModel)]="poNumber" name="poNumber" placeholder="Enter PO or Job Number" (input)="onPoNumberInput($event)">
			</label>

			<div class="place-order">
				<button class="btn btn-primary" (click)="placeOrder()" [disabled]="!canPlaceOrder">Submit Request</button>
			</div>
			@if(canPlaceOrder){
			<div class="email-info-section mt-1">
				<p class="p-0 m-0">You can review your request before final submission.</p>
			</div>
		}
		</aside>
	</div>
</div>
